import {
  parseGameName,
  renderWebComponent,
  string2obj
} from "../../../utils/utils";


export class GameNameParserComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }

  render() {
    const html = `              
      <span class={this.props.additionalClasses1 ? this.props.additionalClasses1 : ''}>
        ${ parseGameName(this.props.game_name, this.props.isProduct) }
      </span>
    `

    renderWebComponent(html, this.shadowRoot);
  }
}

window.customElements.define("game-name-parser-component", GameNameParserComponent);